import { Fragment, PropsWithChildren } from "react";
import { IntlProvider } from "react-intl";
import localeData, { LOCALES } from "./locale";

export default ({
  children,
  locale = LOCALES.ENGLISH,
}: PropsWithChildren<{ locale: string }>) => (
  <IntlProvider
    locale={locale}
    textComponent={Fragment}
    messages={localeData[locale]}
  >
    {children}
  </IntlProvider>
);
